export const LOAN_EDITOR_CUSTOM_FORMS_ERROR_MESSAGES = {
  LOAD: 'Failed to load loan editor custom forms.',
  CREATE: 'Failed to create loan editor custom form.',
  UPDATE: 'Failed to update loan editor custom form.',
  UPDATE_LAYOUT: 'Failed to update loan editor custom form layout.',
  DELETE: 'Failed to delete loan editor custom form.',
};

export const LOAN_EDITOR_CUSTOM_FORMS_SUCCESS_MESSAGES = {
  CREATE: 'Loan editor custom form created successfully.',
  UPDATE: 'Loan editor custom form updated successfully.',
  UPDATE_LAYOUT: 'Loan editor custom form layout updated successfully.',
  DELETE: 'Loan editor custom form deleted successfully.',
};
